export default __webpack_public_path__ + "static/media/lognPageImg.a7ac07dc.svg";